var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dice-container",class:{ active: _vm.isActive }},[_c('div',{staticClass:"dice",class:[_vm.diceClass, _vm.valueClass, { active: _vm.isActive }],on:{"click":function($event){return _vm.hide()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }